<script setup>
defineProps({
  user: {
    type: Object,
    required: true,
    default: () => ({
      fullName: "",
      iin: "",
    }),
  },
});
</script>

<template>
  <div class="profile">
    <!--    <div class="title">{{ $t("Кабинет клиента") }}</div>-->
    <div class="user">
      <div class="name">{{ user.fullName || $t("Не указано") }}</div>
      <div class="iin">{{ $t("ИИН:") }} {{ user.iin || $t("Не указано") }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.profile {
  @apply w-full flex flex-col gap-3;

  .title {
    @apply text-foreground text-xl font-bold leading-7;
  }

  .user {
    @apply flex flex-col gap-1;
  }

  .name {
    @apply text-foreground text-sm font-semibold leading-5;
  }

  .iin {
    @apply text-muted-foreground text-sm font-normal leading-5;
  }
}
</style>
